<script>
import { environment } from "@app/store/envStore.svelte.js";
/* Firebase */
import firebase from '@app/configs/firebase.js';
import * as m from '@app/paraglide/messages.js';
import { replace } from 'svelte-spa-router';
async function logout() {
    try {
        if (environment.online){
            await firebase.auth().signOut();
        } else {
            //Clear Local Storage key for `cc-offline-license`
            localStorage.removeItem('cc-offline-license');
        }        
    } catch (error) {
        console.log(error);
    } finally {        
        // Navigate to /login
        replace("/login");
    }   
}
</script>
<a class="dropdown-item" 
   href="#!/" 
   id="logoutMenuItem"
   role="menuitem"
   aria-label={m.logout_from_application()}
   onclick={logout}>{m.logout()}</a>